import {FileUpload, MoreHoriz} from "@mui/icons-material";
import {IconButton} from "@mui/material";
import React, {useRef, useState} from "react";
import {UserRoleType} from "../../../../common/access/UserRoleType";
import neo4jExportApiClient from "../../../../common/apis/neo4j/Neo4jExportApiClient";
import {useCurrentUser} from "../../../../common/hooks/useUser";
import ConfirmationDialog from "../../../../components/dialogs/ConfirmationDialog";
import {Menu} from "../../../../components/menu/Menu";
import {MenuItem} from "../../../../components/menu/MenuItem";
import Page from "../../../../components/page/Page";
import PageContent from "../../../../components/page/PageContent";
import TitleHeader from "../../../../components/TitleHeader";
import {_transl} from "../../../../store/localization/TranslMessasge";
import {ErrorTranslationKey} from "../ErrorTranslationKey";
import Snackbar from "../snackbar/Snackbar";
import GraphQueryGridWithFilter from "./GraphQueryGridWithFilter";
import {GraphQueryTranslationKey} from "./GraphQueryTranslationKey";


export default function GraphQueryPage() {
    const pageMenuIconRef = useRef<HTMLButtonElement | null>(null);
    const [pageMenuOpened, setPageMenuOpened] = useState<boolean>(false);
    const [exportModelToNeo4JDialogOpened, setExportModelToNeo4JDialogOpened] = useState<boolean>(false);

    const user = useCurrentUser();
    const isAtLeastSpravce = user?.role === UserRoleType.ROLE_ADMIN || user?.role === UserRoleType.ROLE_SPRAVCE;

    function showExportModelToNeo4JDialog() {
        setExportModelToNeo4JDialogOpened(true);
        setPageMenuOpened(false);
    }

    function exportModelToNeo4J() {
        setExportModelToNeo4JDialogOpened(false);

        Snackbar.info(_transl(GraphQueryTranslationKey.GRAPH_MODEL_EXPORT_STARTED));
        neo4jExportApiClient.exportModelToNeo4j()
                .then(() => Snackbar.success(_transl(GraphQueryTranslationKey.REFREH_GRAPH_MODEL_SUCCESS)))
                .catch((err) => Snackbar.error(_transl(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), err));
    }

    return (
            <>
                <Page>
                    <TitleHeader title={_transl(GraphQueryTranslationKey.QUERIES_TITLE)}
                            right={isAtLeastSpravce ?
                                    <IconButton onClick={() => setPageMenuOpened(true)}
                                            ref={element => pageMenuIconRef.current = element}>
                                        <MoreHoriz/>
                                    </IconButton>
                                    : undefined
                            }/>
                    <PageContent>
                        <GraphQueryGridWithFilter resourceId={"queries"}/>
                    </PageContent>
                </Page>

                <Menu open={pageMenuOpened}
                        onClose={() => setPageMenuOpened(false)}
                        anchorEl={pageMenuIconRef.current}>
                    <MenuItem label={_transl(GraphQueryTranslationKey.REFRESH_GRAPH_MODEL)}
                            icon={<FileUpload/>}
                            onClick={() => showExportModelToNeo4JDialog()}/>
                </Menu>

                <ConfirmationDialog open={exportModelToNeo4JDialogOpened}
                        title={_transl(GraphQueryTranslationKey.REFRESH_GRAPH_MODEL_QUESTIONMARK)}
                        confirmationText={_transl(GraphQueryTranslationKey.GRAPH_MODEL_WILL_BE_REFRESHED_FROM_MAIN_DATA_SOURCE)}
                        onConfirm={() => exportModelToNeo4J()}
                        onReject={() => setExportModelToNeo4JDialogOpened(false)}/>
            </>
    );
}
